<!--

Copyright Paul B. Lucas (C) 2025  ALL RIGHTS RESERVED.
Licensed to the University of Illinois Urbana Champaign

This component is rendered as an initial screen for all logins.  Is it essentially a placeholder for
notices and other information rendered as either h3 or p text. 
Revisions:
    02/13/2025      pblucas     initial creation
 

-->
<template>
    <div class="home_01" >
        <div class="home_notice" v-if="config.notice.length > 0">
            <p class="home_p_notice_1" >{{ config.title }} Legal Notice</p>
            <p class="home_p_notice_2">{{ config.notice }}</p>
        </div>
        <div v-else>
            <br/>
            <p class="home_p_notice_1" >&nbsp;<br/><br/></p>
            <p class="home_p_notice_2">&nbsp;<br/><br/></p>
        </div>
        <h3 class="h3_01"> {{  applicationName }}</h3>

    </div>

</template>

<script>
    import {ref, computed}          from 'vue'
    //import Component from '@/components/component.vue'
    import { useStore }             from 'vuex'
    import useRefreshAPI            from '@/composables/useRefreshAPI'
    import usePermissionsAPI        from '@/composables/usePermissionsAPI'

    export default {
        name: 'home',
        components: {
        },
        props: [
            'claims',
            'gat'
        ],

        emits: [
        ],
    
        setup(props)    {

            const { checkStoreForRefresh }  =   useRefreshAPI()
            const { checkAdminGroups }      =   usePermissionsAPI() 
            const store                     =   useStore()

            const config                    = computed( () => store.state.config)

            // MARK:  refresh store from database if global browser refresh fubars the store
            checkStoreForRefresh()
            checkAdminGroups(props.claims)

            // application name
            const applicationName     =   ref("Equipment/Asset Manager")

            return {config, applicationName}
        },

        data() {

            return { }
        },

        // hooks
        beforeMount() {

        },
        mounted() {
            //console.log("App:: store: user netid from localStorage: "+localStorage.getItem("user-netid"))
        },
        beforeUpdate() {


        }
    }
</script>

<style scoped>
.home_01    {
    width: 100vw;
    min-height: 80vw; 
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    /* justify-content: space-evenly; */
    background: url('@/assets/equip-V1.png') no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: 50%;
    padding: 0;
    margin: 0;    
}
.h3_01 {
    order: 1;
    font-family:Monserrat, Avenir, Helvetica, Arial, sans-serif;
    font-weight: bold;
    font-size: 28pt;
    color: #13294B;
    text-shadow: 4px 4px #E8E9EB;
    padding: 5px;
    margin: 55% 2px 0;
}
.home_notice {
    width: 50%;
    margin: 10% auto 0;
    padding: 10px;
    background-color: #E8E9EB;
    border-style: solid;
    border-width: 2px;
    border-color: #FF5F05;
    
   
}
.home_p_notice_1    {
    margin: 0;
    padding: 0 2px 5px;
    text-align: left;
    color: black;
    font-family:Monserrat, Avenir, Helvetica, Arial, sans-serif;
    font-weight: bold;
    font-size: 12pt;
}
.home_p_notice_2    {
    margin: 0 auto;
    padding: 0 2px;
    text-align: justify;
    color: black;
    font-family:Monserrat, Avenir, Helvetica, Arial, sans-serif;
    font-weight: normal;
    font-size: 12pt;
}
@media screen and (max-width: 1200px) {
    .h3_01 {
        font-size: 26pt;  
        margin: 54% 2px 0;
    }
}
@media screen and (max-width: 1000px) {
    .h3_01 {
        font-size: 24pt;  
        margin: 52% 2px 0;
    }
}
@media screen and (max-width: 800px) {
    .h3_01 {
        font-size: 20pt;  
        margin: 50% 2px 0;
    }
}
@media screen and (max-width: 620px) {
    .h3_01 {
        font-size: 16pt;  
        margin: 50% 2px 0;
    }
}
</style>